import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedDiv: ''
  },
  
  getters: {
    getSelectedDiv: state => {
      return state.selectedDiv;
    }
  },
  
  mutations: {
    setSelectedDiv(state, id) {
      state.selectedDiv = id;
    }
  },
  
  actions: {
    setSelectedDiv(context, id) {
      context.commit('setSelectedDiv', id);
    }
  }
});